import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/static/icons/arrow-right-pixel.png'


const _withScopeId = n => (_pushScopeId("data-v-39c9bc08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Filtros", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Lojas", -1))
const _hoisted_4 = { class: "filter__shops" }
const _hoisted_5 = ["id", "name", "value", "checked"]
const _hoisted_6 = { class: "filter__detail" }
const _hoisted_7 = ["for"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter__line" }, null, -1))
const _hoisted_9 = { class: "filter__shops" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Valores", -1))
const _hoisted_11 = ["id", "name", "value", "checked", "onChange"]
const _hoisted_12 = { class: "filter__detail" }
const _hoisted_13 = ["for"]
const _hoisted_14 = { class: "filter__inputs" }
const _hoisted_15 = ["value"]
const _hoisted_16 = ["value"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "submit" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filters__line" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Categorias", -1))
const _hoisted_20 = { class: "filter__shops" }
const _hoisted_21 = ["id", "name", "value", "checked"]
const _hoisted_22 = { class: "filter__detail" }
const _hoisted_23 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['filter__content', { open: _ctx.open }]),
      id: "filters"
    }, [
      _createElementVNode("div", {
        class: "filter__select",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.select()))
      }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "Ícone de seta",
          style: _normalizeStyle(_ctx.open ? `transform: rotate(90deg);` : '')
        }, null, 4),
        _hoisted_2
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters.shops, (shop, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "filter__checkbox",
            key: index
          }, [
            _createElementVNode("input", {
              type: "checkbox",
              id: shop.id + 'shop',
              name: shop.name,
              value: shop.id,
              checked: _ctx.$route.query.shop?.includes(String(shop.id)),
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectShops($event.target)))
            }, null, 40, _hoisted_5),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", {
                for: shop.id + 'shop'
              }, _toDisplayString(shop.name), 9, _hoisted_7),
              _createElementVNode("span", null, "(" + _toDisplayString(shop.quantityProducts) + ")", 1)
            ])
          ]))
        }), 128))
      ]),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayPrices, (price, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "filter__checkbox",
            key: index
          }, [
            _createElementVNode("input", {
              type: "checkbox",
              id: price.id + 'price',
              name: price.label,
              value: price.id,
              checked: _ctx.$route.query.price?.includes(String(price.id)),
              onChange: ($event: any) => (_ctx.selectPrice(price, $event.target))
            }, null, 40, _hoisted_11),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", {
                for: price.id + 'price'
              }, _toDisplayString(price.label), 9, _hoisted_13),
              _createElementVNode("span", null, "(" + _toDisplayString(_ctx.getQuantityByPrice(price.id)) + ")", 1)
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("form", {
            id: "prices",
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
          }, [
            _createElementVNode("input", {
              type: "number",
              placeholder: "Mínimo",
              class: "filter__input-price",
              name: "min",
              min: "0",
              value: _ctx.minPrice,
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectMinInputPrice($event.target)))
            }, null, 40, _hoisted_15),
            _createElementVNode("input", {
              type: "number",
              placeholder: "Máximo",
              class: "filter__input-price",
              name: "max",
              min: "0",
              value: _ctx.maxPrice,
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectMaxInputPrice($event.target)))
            }, null, 40, _hoisted_16),
            _hoisted_17
          ], 32)
        ])
      ]),
      _hoisted_18,
      _hoisted_19,
      _createElementVNode("div", _hoisted_20, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters.categories, (category, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "filter__checkbox",
            key: index
          }, [
            _createElementVNode("input", {
              type: "checkbox",
              id: category.id + 'category',
              name: category.name,
              value: category.id,
              checked: _ctx.$route.query.category?.includes(String(category.id)),
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectCategories($event.target)))
            }, null, 40, _hoisted_21),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("label", {
                for: category.id + 'category'
              }, _toDisplayString(category.name), 9, _hoisted_23),
              _createElementVNode("span", null, "(" + _toDisplayString(category.quantityProducts) + ")", 1)
            ])
          ]))
        }), 128))
      ])
    ], 2)
  ]))
}